module.exports = __webpack_public_path__ + "img/control_de_calidad_16-9_1440.596ac384.webp";